import { component } from "picoapp";
import { TABBED_CAROUSEL_SETTINGS } from "../tbsp-carousel--constants";

export const tabbedCarousel = component(async (node) => {
  const [{ default: Splide }, { Intersection }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide-extension-intersection"),
    import("@splidejs/splide/css/core"),
  ]);

  const splide = new Splide(node, TABBED_CAROUSEL_SETTINGS);

  let observedContent: HTMLElement | null = null;

  const updateActiveSlideHeight = () => {
    const slideComponent = splide.Components.Slides.getAt(splide.index);

    if (!slideComponent) {
      return;
    }

    const slide = slideComponent.slide;
    const contentRoot = slide.firstElementChild;

    if (!(contentRoot instanceof HTMLElement)) {
      return;
    }

    const splideList = slide.closest<HTMLElement>(".splide__list");

    if (!splideList) {
      return;
    }

    splideList.style.height = `${contentRoot.offsetHeight}px`;
  };

  const scheduleHeightUpdate = () => {
    requestAnimationFrame(updateActiveSlideHeight);
  };

  const resizeObserver = new ResizeObserver(() => {
    scheduleHeightUpdate();
  });

  const observeActiveSlideContent = () => {
    const slideComponent = splide.Components.Slides.getAt(splide.index);

    if (!slideComponent) {
      return;
    }

    const contentRoot = slideComponent.slide.firstElementChild;

    if (!(contentRoot instanceof HTMLElement)) {
      return;
    }

    if (observedContent !== contentRoot) {
      if (observedContent) {
        resizeObserver.unobserve(observedContent);
      }

      observedContent = contentRoot;
      resizeObserver.observe(contentRoot);
    }
  };

  splide.on("pagination:mounted", ({ items, list }) => {
    splide.Components.Slides.forEach(({ index, slide }) => {
      const name = slide.dataset.tabName || "";
      items[index].button.textContent = name;
    });

    list.classList.add("splide__pagination--tab");

    let dataSet = {
      mtrAs: "clickModule",
      mtrPosition: 0,
      mtrTarget: "tab",
      mtrTrack: "click",
    };

    items.forEach((item, idx) => {
      item.button.classList.add("splide__pagination__page--tab");
      item.li.classList.add("splide__pagination__page--tab_item");

      dataSet = {
        ...dataSet,
        mtrPosition: idx + 1,
      };

      Object.entries(dataSet).forEach(([key, value]) => {
        item.button.dataset[key] = String(value);
      });
    });

    list.classList.remove("hidden");
    observeActiveSlideContent();
    scheduleHeightUpdate();
  });

  splide.on("intersection:in", function () {
    splide.on("active", ({ slide }) => {
      const video = slide.querySelector("video");

      if (video) {
        video.play().catch();
      }
    });

    splide.on("inactive", ({ slide }) => {
      const video = slide.querySelector("video");

      if (video) {
        video.muted = true;
        video.pause();
      }
    });

    node.querySelectorAll("video").forEach((video) => {
      video.preload = "auto";
    });
  });

  splide.on("moved resize", () => {
    observeActiveSlideContent();
    scheduleHeightUpdate();
  });

  splide.mount({ Intersection });

  return () => {
    resizeObserver.disconnect();
    observedContent = null;
  };
});
